function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#37474F;}\r\n\t.st1{fill:#B0BEC5;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M51.2,39.9h-5.6l-4.3-6.7l0,0v6.7h-4.5V22.5h6.7c3.4,0,6,1.6,6,5.3c0,2.4-1.3,4.5-3.8,4.9L51.2,39.9z  M41.3,30.3h0.4c1.5,0,3.1-0.3,3.1-2.2c0-1.9-1.7-2.2-3.1-2.2h-0.4V30.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M64.5,34.7h-8.8c0,1.7,0.9,2.6,2.6,2.6c0.9,0,1.5-0.3,2-1.1h4c-0.7,2.8-3.3,4-6,4c-3.9,0-6.8-2.2-6.8-6.3 c0-3.9,2.7-6.3,6.5-6.3c4.1,0,6.5,2.5,6.5,6.6V34.7z M60.6,32.3c-0.2-1.1-1.2-1.9-2.4-1.9S56,31,55.7,32.3H60.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M79.3,38.7c0,5-2.5,7-6.8,7c-2.7,0-6.3-1.4-6.7-4.5h4.7c0.1,0.4,0.4,0.7,0.8,0.9s0.8,0.3,1.2,0.3 c2.3,0,2.7-1.5,2.7-3.4v-0.6C74.1,39.5,73,40,71.5,40c-3.4,0-5.8-2.6-5.8-6s2.4-6.4,6-6.4c1.4,0,2.6,0.5,3.5,1.6l0,0V28h4.2 L79.3,38.7L79.3,38.7z M69.9,33.9c0,1.5,1,2.6,2.7,2.6s2.7-1.1,2.7-2.6c0-1.4-1-2.7-2.7-2.7S69.9,32.4,69.9,33.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M86.4,23.5c0,1.3-1.1,2.3-2.3,2.3c-1.3,0-2.3-1.1-2.3-2.3c0-1.3,1.1-2.3,2.3-2.3S86.4,22.3,86.4,23.5z  M86.1,39.9h-4.2V28.1h4.2V39.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M96.7,31.1c-0.6-0.3-1.5-0.6-2.3-0.6c-0.5,0-1.3,0.2-1.3,0.8c0,0.8,1.3,0.9,1.9,1c2,0.4,3.4,1.3,3.4,3.5 c0,3.1-2.8,4.4-5.6,4.4c-1.7,0-3.3-0.5-4.8-1.4l1.5-2.9c0.9,0.6,2.3,1.2,3.3,1.2c0.5,0,1.3-0.3,1.3-0.9c0-0.9-1.3-1-2.6-1.3 S89,34,89,31.9c0-2.9,2.6-4.2,5.2-4.2c1.3,0,2.7,0.2,3.9,0.8L96.7,31.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M105.3,39.9h-4.2v-8.3h-1.4v-3.4h1.4v-3.5h4.2v3.5h2.4v3.4h-2.4V39.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M113.2,30L113.2,30c0.9-1.4,2.2-2.1,3.9-2.1h0.8v4c-0.6-0.3-1.1-0.4-1.8-0.4c-2.3,0-2.9,1.5-2.9,3.6v4.8H109 V28.1h4.2V30z"
}), React.createElement("path", {
  className: "st0",
  d: "M132.3,34c0,4-3.3,6.3-7.1,6.3c-3.8,0-7.1-2.3-7.1-6.3s3.3-6.3,7.1-6.3S132.3,30,132.3,34z M122.5,34 c0,1.5,1,2.6,2.7,2.6s2.7-1.1,2.7-2.6c0-1.4-1-2.7-2.7-2.7S122.5,32.5,122.5,34z"
}), React.createElement("path", {
  className: "st0",
  d: "M43.5,53.5h-5.4c0,1,0.5,1.6,1.6,1.6c0.5,0,0.9-0.2,1.2-0.7h2.5c-0.4,1.7-2,2.5-3.7,2.5 c-2.4,0-4.2-1.3-4.2-3.8c0-2.4,1.6-3.8,4-3.8c2.5,0,3.9,1.5,3.9,4v0.2H43.5z M41.2,52c-0.1-0.7-0.8-1.1-1.4-1.1 c-0.7,0-1.4,0.4-1.5,1.1H41.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M47.3,56.7h-2.5V45h2.5V56.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M56.3,53.5H51c0,1,0.5,1.6,1.6,1.6c0.5,0,0.9-0.2,1.2-0.7h2.5c-0.4,1.7-2,2.5-3.7,2.5c-2.4,0-4.2-1.3-4.2-3.8 c0-2.4,1.6-3.8,4-3.8c2.5,0,3.9,1.5,3.9,4V53.5z M53.9,52c-0.1-0.7-0.8-1.1-1.4-1.1c-0.7,0-1.4,0.4-1.5,1.1H53.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M62.7,51.8c-0.4-0.3-0.8-0.5-1.3-0.5c-1,0-1.8,0.8-1.8,1.8s0.7,1.8,1.8,1.8c0.4,0,0.9-0.2,1.3-0.5v2.2 c-0.6,0.3-1.2,0.4-1.8,0.4c-2.1,0-3.9-1.6-3.9-3.8c0-2.3,1.8-3.9,4-3.9c0.6,0,1.2,0.1,1.7,0.4V51.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M67,56.7h-2.5v-5.1h-0.8v-2.1h0.8v-2.2H67v2.2h1.4v2.1H67V56.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M71.8,50.7L71.8,50.7c0.5-0.9,1.4-1.3,2.4-1.3h0.5v2.5c-0.4-0.2-0.7-0.2-1.1-0.2c-1.4,0-1.8,0.9-1.8,2.2v2.9 h-2.5v-7.2h2.5V50.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M83.7,53.1c0,2.4-2,3.8-4.3,3.8s-4.3-1.4-4.3-3.8s2-3.8,4.3-3.8C81.7,49.2,83.7,50.6,83.7,53.1z M77.8,53.1 c0,0.9,0.6,1.6,1.6,1.6S81,54,81,53.1c0-0.9-0.6-1.6-1.6-1.6S77.8,52.2,77.8,53.1z M79.1,48.4L78,47.6l2-2.4l1.6,1.1L79.1,48.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M87.4,50.4L87.4,50.4c0.6-0.9,1.3-1.2,2.3-1.2c1.9,0,2.7,1.2,2.7,3v4.4h-2.5v-3.5c0-0.7,0.1-1.9-1.1-1.9 c-1,0-1.3,0.8-1.3,1.7v3.7H85v-7.2h2.5L87.4,50.4L87.4,50.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M96.8,46.7c0,0.8-0.6,1.4-1.4,1.4S94,47.5,94,46.7s0.6-1.4,1.4-1.4S96.8,45.9,96.8,46.7z M96.7,56.7h-2.5v-7.2 h2.5V56.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M103.5,51.8c-0.4-0.3-0.8-0.5-1.3-0.5c-1,0-1.8,0.8-1.8,1.8s0.7,1.8,1.8,1.8c0.4,0,0.9-0.2,1.3-0.5v2.2 c-0.6,0.3-1.2,0.4-1.8,0.4c-2.1,0-3.9-1.6-3.9-3.8c0-2.3,1.8-3.9,4-3.9c0.6,0,1.2,0.1,1.7,0.4C103.5,49.7,103.5,51.8,103.5,51.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M113.3,53.1c0,2.4-2,3.8-4.3,3.8s-4.3-1.4-4.3-3.8s2-3.8,4.3-3.8S113.3,50.6,113.3,53.1z M107.3,53.1 c0,0.9,0.6,1.6,1.6,1.6s1.6-0.7,1.6-1.6c0-0.9-0.6-1.6-1.6-1.6S107.3,52.2,107.3,53.1z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M17.9,40h-5.6l-3.2-6.7l0,0L8,40H3.5l2.7-17.3H13c3.4,0,5.8,1.6,5.2,5.3c-0.4,2.4-2,4.5-4.6,4.9L17.9,40z  M9.5,30.5H10c1.5,0,3.2-0.3,3.5-2.2c0.3-1.9-1.3-2.2-2.8-2.2h-0.4L9.5,30.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M32,34.8h-8.8c-0.3,1.7,0.5,2.6,2.2,2.6c0.9,0,1.6-0.3,2.2-1.1h4c-1.1,2.8-4,4-6.6,4c-3.9,0-6.5-2.2-5.8-6.3 c0.6-3.9,3.7-6.3,7.5-6.3c4.1,0,6.1,2.5,5.4,6.6L32,34.8z M28.5,32.4c0-1.1-0.9-1.9-2.1-1.9s-2.3,0.6-2.8,1.9H28.5z M25.8,26.5 l-1.6-1.4l3.9-4l2.3,1.8L25.8,26.5z"
}));

var SvgApp = function SvgApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 64",
    style: {
      enableBackground: "new 0 0 140 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app.cbfbaa81.svg";
export { ForwardRef as ReactComponent };